import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import JournalInputs from "./JournalInputs";

export default function CustomerDebtCorrectionJournalForm() {
  return (
    <ArrayInput
      source="customer_debt_correction_journals"
      defaultValue={[
        {
          chart_of_account_id: "", // "28be7da8-d105-40c5-9972-3d1ae0e631ee", // FIXME: sesuaikan dgn ID Account Receivable
          debit: 0,
          credit: 0,
        },
        {
          chart_of_account_id: "",
          debit: 0,
          credit: 0,
        },
      ]}
    >
      <SimpleFormIterator
        fullWidth={true}
        inline={true}
        disableReordering
        sx={{
          "& .RaSimpleFormIterator-form": {
            width: "100%",
          },
          "& .RaSimpleFormIterator-line": {
            borderBottom: "none",
          },
        }}
        // getItemLabel={(index) => `#${index + 1}`}
      >
        <FormDataConsumer>{JournalInputs}</FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
